import { useState, useEffect } from 'react';
import { useRefundAmount } from '../../../../../hooks';
import CorporateLeadsForm from './corporate-leads-form';

export const NewHeroComponent = () => {
  const [integerPart, setIntegerPart] = useState(0);
  const [decimalPart, setDecimalPart] = useState(0);
  const refund = useRefundAmount(418.26).refund_amount;
  const integerPartEnd = Math.floor(refund);
  const decimalPartEnd = Math.round((refund - integerPartEnd) * 100);
  useEffect(() => {
    const end = integerPartEnd;
    const duration = 1000;
    const startTime = performance.now();

    const animate = (time: number) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const value = Math.floor(progress * end);
      setIntegerPart(value);
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [integerPartEnd]);

  useEffect(() => {
    const end = decimalPartEnd;
    const duration = 2000;
    const startTime = performance.now();

    const animate = (time: number) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const value = Math.floor(progress * end);
      setDecimalPart(value);
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [decimalPartEnd]);
  return (
    <div className="flex sm:flex-col items-center">
      <div className="left w-2/3 sm:w-full flex flex-col justify-center mt-[-20px] sm:mt-1">
        <div className="sm:flex sm:justify-center pt-10 sm:p-0">
          <div className="text-s-base text-gray-600 font-medium rounded-3xl border border-gray-200 px-3 py-1 sm:mt-6 sm:text-s-14 w-[410px] text-center ">
            <span className="text-s-20 text-green-600 sm:text-s-14 font-bold w-20">
              {integerPart}.{decimalPart.toString().padStart(2, '0')} Cr{' '}
            </span>
            worth of refunds processed last year
          </div>
        </div>
        <div className="heading text-[52px]  font-semibold sm:text-center sm:mt-4 sm:text-s-32 max-w-[605px]">
          <span className="text-blue-600 sm:text-s-32">
            Trusted tax & financial partner{' '}
          </span>
          — all year round
        </div>

        {/* <div className="sm:fixed sm:bottom-0 sm:left-0 sm:z-100 sm:bg-white flex gap-x-4 mt-4 sm:justify-center sm:flex-wrap sm:w-full sm:py-4 sm:px-4 ">
          <a
            href="#Recommended-plan"
            className="sm:w-full"
            onClick={() =>
              handleTrack({
                categoryName: 'pricing-page-new',
                label: 'hire-expert_button',
                obj: null,
              })
            }
          > */}
        {/* <Button
              variant={ButtonVariants.bluebordered}
              className="sm:w-full hidden sm:block"
            >
              View Plans
            </Button>
            <Button
              variant={ButtonVariants.bluefilled}
              className="sm:w-full sm:hidden block"
            >
              View Plans
            </Button>
          </a> */}

        {/* <a
            href="#Recommended-plan"
            className="sm:w-full sm:mt-2"
            onClick={() =>
              handleTrack({
                categoryName: 'homepage',
                label: 'need-help_button',
                obj: null,
              })
            }
          >
            <Button
              variant={ButtonVariants.bluebordered}
              className="sm:w-full h-12"
            >
              Need Help Picking a Plan?
            </Button>
          </a> */}
        {/* </div> */}

        <ul className="flex justify-between max-w-md pt-6 sm:justify-center">
          {[
            // {
            //   src: 'https://assets.clear.in/cleartax/images/1746018496_frame1814221524.svg',
            //   text: 'Guaranteed 24-hour Filing',
            // },
            {
              src: 'https://assets.clear.in/cleartax/images/1751363387_frame1814221524.svg',
              text: 'No Notice Stress',
            },
            {
              src: 'https://assets.clear.in/cleartax/images/1751363438_frame18142215241.svg',
              text: 'Live Video Sessions',
            },
            {
              src: 'https://assets.clear.in/cleartax/images/1751363497_frame18142215242.svg',
              text: 'Top Rated Tax Experts',
            },
            {
              src: 'https://assets.clear.in/cleartax/images/1763041002_advisoryservicesicon2.png',
              text: '24x7 Expert Support',
            },
          ].map(({ src, text }) => (
            <li key={text} className="flex flex-col items-center w-1/4">
              <img src={src} alt={text} className="mb-2 h-12 w-12" />
              <div className="font-semibold text-s-14 text-gray-600 text-center max-w-[80%] break-normal sm:text-s-12">
                {text}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="sm:mt-5 right">
        <CorporateLeadsForm />
      </div>
    </div>
  );
};
